import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

import SnackbarContent from '@material-ui/core/SnackbarContent'

import Icon from '@eig-builder/core-ui/Icon'

import LinkButton from 'core/components/link-button'
import { UserHasAccessForFeature } from '../../../helpers/role-management'
import { ROLE_FEATURES } from '../../../helpers/role-management/role-mapping.js'

import Text from '@eig-builder/module-localization'

const useStyles = makeStyles(theme => ({
  snackbar: {
    backgroundColor: theme.palette.error.main,
    width: 'fit-content',
    marginBottom: theme.spacing(4)
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  }
}))

const SdnMessage = ({ account }) => {
  const classes = useStyles()

  const hasAccessToFeature = UserHasAccessForFeature(ROLE_FEATURES.ACCOUNT_DETAILS)
  const sanctionUrl = `/compliance/sdn/${account.partnerId}/${account.id}`

  if (!account.isPendingSdnReview) {
    return null
  }

  return <SnackbarContent
    className={classes.snackbar}
    message={
      <span className={classes.message}>
        <Icon className={`${classes.icon} ${classes.iconVariant}`} />
        <Text message='modules.crm.components.account.suspicious' />
      </span>
    }
    action={
      hasAccessToFeature
        ? [<LinkButton
          external
          to={sanctionUrl}
          dataElementSuffix='account-sdn-message--view'
          size='small'
          variant='text'
          color='default'
        >
          View
        </LinkButton>]
        : []
    }
  />
}

SdnMessage.propTypes = {
  account: PropTypes.object.isRequired
}

export default SdnMessage
